import './styles.scss';
import goldIdentity from '../../assets/gold-identity.png'

function Footer() {
    return (
        <div id='footer-section'>
            <div className="container-footer">
                <div className='footer-left'>
                    <img src={goldIdentity} alt='LM' />
                    <div className='footer-address'>
                        <h3>Endereço</h3>
                        <span><i className="fa-solid fa-location-dot"></i>Clínica IVA - Rua Altino Serbeto de Barros, 173, Edf. Atlantis, Salas 1002 e 1005. Itaigara - Salvador/BA</span>
                        <span><i className="fa-solid fa-location-dot"></i>Clínica CLAP – Avenida Tancredo Neves,805-A, Centro Médico Iguatemi, Sala 303. Caminho das Árvores, Salvador/BA</span>

                    </div>
                </div>
                <div className='footer-center'>
                    <h3><i className="fa-brands fa-whatsapp"></i>Agende sua avaliação!</h3>
                    <span>(71) 9 9730‑3062</span>

                    <div className='footer-right-responsive'>
                        <h3>Siga-nos</h3>
                        <a href='https://www.instagram.com/laismuhana/' target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                    </div>

                </div>
                <div className='footer-right'>
                    <h3>Siga-nos</h3>
                    <a href='https://www.instagram.com/laismuhana/' target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
        </div>
    );
}

export default Footer;
